import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import NavigationBar from "../layout/NavigationBar";
import Footer from "../layout/footer";
import 'datatables.net-dt/css/jquery.dataTables.css';
import $ from 'jquery';
import 'datatables.net';

function Category() {
    const navigate = useNavigate();
    const [categoryData, setCategoryData] = useState([]);
    const [deleteCategoryId, setDeleteCategoryId] = useState("");
    const [deleteTitle, setDeleteTitle] = useState("");
    const [dataTable, setDataTable] = useState(null);

    // useEffect(() => {
    //     // Update the page layout on component mount
    //     const pathname = window.location.pathname;
    //     if (pathname === '/list') {
    //         console.log("Adding classes to the body.");
    //         document.body.classList.remove('login-page');
    //         document.body.classList.add('sidebar-mini');
    //     }
    // }, []);

    useEffect(() => {
        // Fetch the data from the API on component mount
        fetchData();
    }, []);

    useEffect(() => {
        // Initialize DataTable if categoryData is available
        if (categoryData.length) {
            if (dataTable) {
                dataTable.destroy();
            }
            const table = $('#category').DataTable({
                data: categoryData,
                columns: [
                    { data: null, render: (data, type, row, meta) => meta.row + 1 }, // S.No
                   
                    { data: 'category' }, // Product title
                    { data: 'subcategory' }, // Price
                    { 
                        data: 'created_date', 
                        render: (data) => new Date(data).toLocaleString() 
                    }, // Date Added
                    { 
                        data: null, 
                        render: (data) => {
                            // <a href="/category_edit?id=${data._id}" class="crsr_pntr"><i class="fa-solid fa-pen mr-2"></i></a>
                            return `
                                <div align="center">
                                     
                                    <a href="#" class="crsr_pntr delete-btn" data-id="${data._id}" data-name="${data.category}" data-toggle="modal" data-target="#modaldelete"><i class="fa-solid fa-trash-can"></i></a>
                                </div>
                            `;
                        } // Action buttons (edit and delete)
                    }
                ],
                pageLength: 10,
                lengthMenu: [5, 10, 25, 50, 75, 100]
            });
            setDataTable(table);

            // Event listener for the delete button
            $('#category').on('click', '.delete-btn', function() {
                const categoryId = $(this).data('id');
                const categoryName = $(this).data('name');
                openDeleteModal(categoryId, categoryName);
            });
        }
    }, [categoryData]);

    const fetchData = () => {
        // Fetching category data from the server
        axios
            .get(process.env.REACT_APP_APIURL + "category/list")
            .then((res) => {
                if (res.data.status === "success") {
                    setCategoryData(res.data.result);
                }
            })
            .catch((err) => {
                console.error("Error fetching category data:", err);
            });
    };

    const deleteCategory = (category_id) => {
        // Delete a category from the server
        axios
            .post(`${process.env.REACT_APP_APIURL}category/delete`, { category_id: category_id, category_status: "delete" })
            .then((res) => {
                if (res.data.status === "success") {
                    // Remove the deleted category from the categoryData state
                    setCategoryData(categoryData.filter(category => category._id !== category_id));
                }
            })
            .catch((err) => {
                console.error("Error deleting category:", err);
            });
    };

    const openDeleteModal = (id, title) => {
        // Open the delete confirmation modal
        setDeleteCategoryId(id);
        setDeleteTitle(title);
    };

    return (
        <div className="wrapper" id="root"> 
            <header>
                <NavigationBar />
            </header>

            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1 className="m-0 txt_lft">Category 
                                    <a href="/category_add">
                                        <i className="fa-solid fa-square-plus ml-2" title="Add Product" />
                                    </a>
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="table-responsive">
                                    <table id="category" className="table table-striped table-bordered txt_lft" style={{ width: '100%' }}>
                                        <thead>
                                            <tr>
                                                <th>S.No</th>
                                                <th>Category</th>
                                                <th>SubCategory</th>
                                                <th>Added On</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />

            {/* Delete Confirmation Modal */}
            <div className="modal fade" id="modaldelete" tabIndex={-1} aria-labelledby="modaldeleteLabel" aria-hidden="true" data-backdrop="static">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="modaldeleteLabel">Delete Product</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <i className="fa-solid fa-xmark" />
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="w-100 d-inline-block text-center">
                                Are you sure you want to delete <br /><span className="fwt_600">{deleteTitle}</span>?
                            </div>
                        </div>
                        <div className="modal-footer justify-content-center">
                            <button 
                                type="button" 
                                className="btn btn-primary" 
                                data-dismiss="modal" 
                                aria-label="Close" 
                                onClick={() => deleteCategory(deleteCategoryId)}
                            >
                                Yes, delete
                            </button>
                            <button 
                                type="button" 
                                className="btn btn-secondary" 
                                data-dismiss="modal" 
                                aria-label="Close"
                            >
                                No, cancel
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Category;
